import React, { useEffect, useRef, useState } from 'react';

/**
 * CountUp: smoothly counts from 0 to `to` when it enters the viewport.
 * Renders the result with an optional suffix (e.g., "K+").
 */
const CountUp = ({ to = 100, suffix = '', duration = 1800, className = '' }) => {
  const [value, setValue] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    if (!ref.current) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !started.current) {
            started.current = true;
            const start = performance.now();
            const animate = (now) => {
              const t = Math.min(1, (now - start) / duration);
              // ease-out-quint
              const eased = 1 - Math.pow(1 - t, 5);
              setValue(Math.round(to * eased));
              if (t < 1) requestAnimationFrame(animate);
            };
            requestAnimationFrame(animate);
          }
        });
      },
      { threshold: 0.4 }
    );
    io.observe(ref.current);
    return () => io.disconnect();
  }, [to, duration]);

  return (
    <span ref={ref} className={className}>
      {value}
      {suffix}
    </span>
  );
};

export default CountUp;
